import { EditLOSV1EventPage } from "./EditLOSV1EventPage";

export default EditLOSV1EventPage;
